import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'shien-program-mikouhyou-gensan',
    title: '支援プログラム未公表減算｜15%減を止めるのは公表ではなく届出',
    description:
        '支援プログラム未公表減算は、ホームページに載せただけでは止まりません。留意事項通知が減算の引き金としているのは都道府県への届出がされていないことです。所定単位数の85/100という減算率、障害児全員が対象になる仕組み、記載必須12項目の文例、保育所等訪問支援が対象外である根拠条文まで整理しました。',
    excerpt:
        '支援プログラムをホームページに公開した。それで減算は止まったつもりでいませんか。引き金になっているのは公表ではなく、都道府県への届出です。',
    category: '運営指導',
    keywords: [
        '支援プログラム未公表減算',
        '支援プログラム 減算 15%',
        '支援プログラム 届出',
        '支援プログラム 記載事項',
        '支援プログラム 公表'
    ],
    publishedAt: '2026-05-26',
    updatedAt: '2026-09-16',
};
